(ns manage.content-mapping-table.view
  (:require [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.table :as t]
            [manage.content-variant-ocp.db.content-mapping :as form]
            [reagent.core :as r]
            [uix.core :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui format-ph-type
  [{:keys [field-name]}]
  (let [bind-control (form/use-bind-control [:content-mappings field-name :type])]
    ($ form-field
       {:sx #js {:flex 1}}
       (r/as-element
        [dropdown (assoc bind-control
                         :options (if (= (:value bind-control) "click")
                                    form/placeholder-click-options
                                    form/placeholder-type-options)
                         :disabled? (= (:value bind-control) "click"))]))))

(defui format-ph-name
  [{:keys [field-name]}]
  (let [path [:content-mappings field-name :name]]
    ($ form-field
       {:err-msg (form/use-error-message path)
        :sx #js {:flex 1}}
       ($ input (form/use-bind-control path)))))

(def columns
  [{:id :field-name
    :label "Column"
    :format identity}
   {:id :placeholder-type
    :label "Placeholder type"
    :format #($ format-ph-type {:field-name %})}
   {:id :placeholder-name
    :label "Placeholder name"
    :format #($ format-ph-name {:field-name %})}])

(defui cell
  [{:keys [id format field-name]}]
  (r/as-element
   [t/table-cell
    {:key id
     :data-testid (str "table-content-mapping__column--" (name id))}
    (format field-name)]))

(defui row
  [{:keys [field-name]}]
  (r/as-element
   [t/table-row {:data-testid :table-content-mapping-data-row
                 :style {:min-height "7rem"}}
    (for [{:keys [id format]} columns]
      ($ cell {:key id :id id :format format :field-name field-name}))]))

(defui table
  []
  (let [{:keys [value]} (use-subscribe [:table.content-mapping/value])]
    (r/as-element
     [t/table {:data-testid :table-feed-mapping}
      [t/table-row {}
       (for [{:keys [id label]} columns]
         ^{:key id} [t/table-head label])]
      (for [field-name value]
        ($ row {:key field-name :field-name field-name}))])))
